<template lang='pug'>
v-expansion-panels(
    focusable
    class="pt-10"
)
    v-expansion-panel(
      v-for="(item,i) in faq"
      :key="i"
    )
      v-expansion-panel-header {{ item.question }}
      v-expansion-panel-content
        div(
            class="mt-2" 
            v-html="item.answer"
        )
</template>

<script>
export default {
  name: "FaqUsers",
  props: {
    data: Array,
  },
  computed: {
    faq() {
      const whatsappNumber = `https://wa.me/${process.env.VUE_APP_CALL_CENTER}`;
      return this.data.map(item => {
        return {
          ...item,
          answer: item.answer.replace(/__WA_NUMBER__/g, whatsappNumber)
        };
      });
    }
  }
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>